'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _row = require('../basic/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('../basic/col');

var _col2 = _interopRequireDefault(_col);

var _form = require('../basic/form');

var _form2 = _interopRequireDefault(_form);

var _input = require('../basic/input');

var _input2 = _interopRequireDefault(_input);

var _button = require('../basic/button');

var _button2 = _interopRequireDefault(_button);

var _queueAnim = require('../basic/queue-anim');

var _queueAnim2 = _interopRequireDefault(_queueAnim);

var _icon = require('../basic/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormItem = _form2["default"].Item;
var createForm = _form2["default"].create;


var SimpleForm = _react2["default"].createClass({
	displayName: 'SimpleForm',
	getValue: function getValue() {
		return this.state.formData;
	},
	getInitialState: function getInitialState() {
		return {
			formData: this.props.formData
		};
	},
	getDefaultProps: function getDefaultProps() {
		return {
			formData: {},
			itemSpan: 24,
			labelSpan: 8,
			wrapperSpan: 16
		};
	},
	componentWillMount: function componentWillMount() {
		//Query可能也需要这个生命周期, 传入defaultValue还有点bug, 尚未修改.
		var formData = this.state.formData;
		var children = void 0;
		if (!this.props.children.length) {
			children = [this.props.children];
		} else {
			children = this.props.children;
		}
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var child = _step.value;

				if (child && child.props && (child.props["defaultValue"] || child.props["value"])) {
					if (child.props["defaultValue"] ? child.props["value"] && child.props["value"] != formData[child.props["name"]] && child.props["value"] != child.props["defaultValue"] : child.props["value"] != formData[child.props["name"]]) {
						formData[child.props["name"]] = child.props["value"];
					}
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator["return"]) {
					_iterator["return"]();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		this.setState({ formData: formData });
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var formData = this.state.formData;
		var children = void 0;
		if (!nextProps.children.length) {
			children = [nextProps.children];
		} else {
			children = nextProps.children;
		}
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var child = _step2.value;

				if (child && child.props && (child.props["defaultValue"] || child.props["value"])) {
					if (child.props["defaultValue"] ? child.props["value"] && child.props["value"] != formData[child.props["name"]] && child.props["value"] != child.props["defaultValue"] : child.props["value"] != formData[child.props["name"]]) {
						formData[child.props["name"]] = child.props["value"];
					}
				}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
					_iterator2["return"]();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		this.setState({ formData: formData });
	},
	setValue: function setValue(func, name, e) {
		var formData = this.state.formData;
		var value = e.target ? e.target.value : e; //Input 传入的是e, select传入的是value
		formData[name] = value;
		this.setState({ formData: formData });
		if (func) func(e);
	},
	render: function render() {
		var formData = this.state.formData;
		var formEntity = [];
		var children = void 0;
		if (!this.props.children.length) {
			children = [this.props.children];
		} else {
			children = this.props.children;
		}
		for (var i in children) {
			//遍历组件, 在这里将所有children变成受控组件.
			if (children[i] && children[i].props) {
				var childName = children[i].props["name"];
				var injectProps = {
					onChange: this.setValue.bind(null, children[i].props["onChange"], children[i].props["name"]),
					value: this.state.formData[childName]
				};
				var child = _react2["default"].cloneElement(children[i], injectProps);
				formEntity.push(_react2["default"].createElement(
					_col2["default"],
					{ span: this.props.itemSpan.toString(), key: i },
					_react2["default"].createElement(
						FormItem,
						{
							label: children[i].props["label"] || children[i].props["labelName"],
							labelCol: { span: this.props.labelSpan },
							wrapperCol: { span: this.props.wrapperSpan } },
						child
					)
				));
			}
		}
		return _react2["default"].createElement(
			'div',
			null,
			_react2["default"].createElement(
				_form2["default"],
				{ horizontal: true, key: 'dummy' },
				_react2["default"].createElement(
					_row2["default"],
					null,
					formEntity
				)
			)
		);
	}
});

exports["default"] = SimpleForm;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/simpleform.jsx
 ** module id = 628
 ** module chunks = 0
 **/